export default "__VITE_ASSET__n0fiZ9V8__"